<form [formGroup]="addressForm" class="form-container">
  <div class="address caption col-12 px-0">
    <label class="address-label float-start" for="fieldAddress"
      [ngClass]="{
      'invalid': streetNameValidator.valid === false || dawaAddressValidator.valid === false,
      'address-label-luckynumber': view === 'luckynumber'
      }">Adresse*</label>
    <div>
      <span class="form-check autocomplete--toggle my-0">
        <input type="checkbox" class="form-check-input" id="chkAddressOnly" name="chkAddressOnly"
          [(ngModel)]="autocomplete" [ngModelOptions]="{standalone: true}" (change)="checkIfAutocomplete()"
          [attr.disabled]="!!player && view === 'competitions' ? 'disabled' : null" />
        <label class="p-0 form-check-label form-check-label--right small-label" for="chkAddressOnly"
          [ngClass]="{'active': dawaInteracted === true }">
          <ng-container>Adressehjælp</ng-container>
        </label>
      </span>
    </div>
  </div>

  <div class="address dawa zindex" [hidden]="!autocomplete"
    [ngClass]="{'invalid': dawaAddressValidator.valid === false}">
    <input id="fieldAddress" placeholder="Skriv og vælg fra listen" #dawaField class="form-control"
      [dawa-address-validator] #dawaAddressValidator="validator" [address]="model.selectedDawaAddress"
      formControlName="DawaAddress" [(ngModel)]="labels.address" (blur)="onAddressBlur($event)" (input)="onDawaInput()"
      spellcheck="false" autocorrect="off" autocomplete="off"
      [attr.disabled]="!!player && view === 'competitions' ? 'disabled' : null"
      [ngClass]="{'form-control-border': view !== 'my-page' && view !== 'checkout' }" />
    <div class="validationmessage">Indtast og vælg din adresse.</div>
  </div>
  <div [hidden]="autocomplete" class="address classic">
    <div [ngClass]="{'invaliddated': parentValid === false }">
      <div class="row pb-3">
        <div class="col-7" [ngClass]="{'invalid': streetNameValidator.valid === false}">

          <input 
            class="form-control"
            [ngClass]="{'form-control-border': view !== 'my-page' && view !== 'checkout' }"
            placeholder="Skriv din adresse (vejnavn)"
            id="fieldAddress"
            name="fieldStreetName"
            formControlName="StreetName"
            (blur)="onFieldBlur($event)"
            (ngModelChange)="addressChanged()"
            [(ngModel)]="model.selectedAddress.StreetName"
            [required-field-validator] #streetNameValidator="validator" />

          <div class="validationmessage">Indtast og vælg dit vejnavn.</div>
        </div>
        <div class="mb-3 col-5 zindex" [ngClass]="{'invalid': streetNoValidator.valid === false}">

          <input 
            class="form-control"
            [ngClass]="{'form-control-border': view !== 'my-page' && view !== 'checkout' }"
            placeholder="Husnr"
            id="fieldHouseNumber"
            name="fieldHouseNumber"
            formControlName="StreetNo"
            (blur)="onFieldBlur($event)"
            (ngModelChange)="addressChanged()"
            [(ngModel)]="model.selectedAddress.StreetNo"
            [required-field-validator] #streetNoValidator="validator" />

          <div class="validationmessage">Indtast dit husnummer.</div>
        </div>
      </div>
      <div class="row pb-3">
        <div class="mb-3 zip col-7" [ngClass]="{'invalid': zipCodeValidator.valid === false }">

          <label class="address-label" for="fieldZipCode" [ngClass]="{'address-label-luckynumber': view === 'luckynumber' }">Postnr*</label>
          <input
            class="form-control"
            [ngClass]="{'form-control-border': view !== 'my-page' && view !== 'checkout' }"
            placeholder="Indtast dit postnr"
            id="fieldZipCode"
            name="fieldZipCode"
            formControlName="ZipCode"
            type="number"
            minlength="4"
            maxlength="4"
            appNumberInput
            (blur)="onFieldBlur($event)"
            [(ngModel)]="model.selectedAddress.ZipCode"
            [required-field-validator] #zipCodeValidator="validator"
            (ngModelChange)="addressChanged()" />

          <div class="validationmessage">Indtast dit postnr.</div>
        </div>
        <div class="mb-3 city col-5" [ngClass]="{'invalid': cityValidator.valid === false }">

          <label class="address-label" for="fieldCity" [ngClass]="{'address-label-luckynumber': view === 'luckynumber' }">By*</label>
          <input
            class="form-control"
            [ngClass]="{'form-control-border': view !== 'my-page' && view !== 'checkout' }"
            placeholder="Indtast din by"
            id="fieldCity"
            name="fieldCity"
            formControlName="CityName"
            (blur)="onFieldBlur($event)"
            [(ngModel)]="model.selectedAddress.CityName"
            [required-field-validator] #cityValidator="validator"
            (ngModelChange)="addressChanged()" />

          <div class="validationmessage">Indtast din by.</div>
        </div>
      </div>
    </div>
    <div class="mb-3 country">

      <label class="address-label" for="selectCountry" [ngClass]="{'address-label-luckynumber': view === 'luckynumber' }">Land*</label>
      <select
        class="form-select"
        id="fieldSelectCountry"
        formControlName="CountryName"
        [(ngModel)]="model.selectedAddress.CountryName"
        (ngModelChange)="addressChanged()"
        [ngClass]="{'form-control-border': view !== 'my-page' && view !== 'checkout' }">

        <option value="-1" hidden disabled>Land</option>
        <option *ngFor="let country of countries" [ngValue]="country.name"> {{country.name}} </option>
      </select>
    </div>
  </div>
</form>
